import React from "react";
import { insulation, qhseBg } from "../../../../assets/images";
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const Insulation = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${qhseBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <SubOtherHero title="Industrial Insulation Services" />
      </div>

      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="max-w-containerSm md:max-w-container mx-auto ">
          <div className="md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row mt-10">
            <div className="md:w-1/2">
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Industrial Insulation Services")}
              </p>

              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t(
                  "Industrial insulation plays a critical role in improving energy efficiency, protecting personnel, minimizing heat loss or gain, and maintaining process stability in industrial environments. Our company provides end-to-end insulation solutions tailored to the needs of oil & gas facilities, power plants, chemical factories, and other industrial facilities."
                )}
              </p>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Our Services Include:")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>
                  {t(
                    "Thermal Insulation: Designed to minimize heat loss or gain in pipelines, tanks, boilers, and equipment. We use materials like mineral wool, glass wool."
                  )}
                </li>
                <li>
                  {t(
                    "Acoustic Insulation: Noise control insulation systems for machinery, ducts, and enclosures to ensure a safer working environment and compliance with health standards."
                  )}
                </li>
                <li>
                  {t(
                    "Cold Insulation: For cryogenic systems and cold storage. Prevents condensation, energy loss, and corrosion under insulation (CUI)."
                  )}
                </li>
                <li>
                  {t(
                    "Removable Insulation Blankets: Custom-made, reusable insulation covers for valves, flanges, and pumps, allowing easy maintenance access."
                  )}
                </li>
                <li>
                  {t(
                    "Fireproof Insulation: Fire-resistant insulation systems for safety-critical infrastructure."
                  )}
                </li>
              </ul>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Why Choose Us?")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>
                  {t(
                    "Use of certified, high-performance materials (including ROCKWOOL)"
                  )}
                </li>
                <li>{t("Trained and safety-certified technicians")}</li>
                <li>
                  {t("Custom engineering solutions based on site surveys")}
                </li>
                <li>
                  {t("On-time execution with minimal disruption to operations")}
                </li>
              </ul>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Applications")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>{t("Refineries")}</li>
                <li>{t("Chemical Plants")}</li>
                <li>{t("Oil & Gas Pipelines")}</li>
                <li>{t("Power Generation Facilities")}</li>
                <li>{t("Storage Terminals")}</li>
              </ul>
            </div>

            {/* Right Image */}
            <div className="md:w-1/2 gap-4 mt-8 md:mt-0">
              <img
                src={insulation}
                alt="Drill Bit 1"
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Insulation;
